// var $ = require('./zepto.1.1.6.min');
import './jquery';
import _gmStore from './gmStore';
const _gs = new _gmStore();
// var dropload = require('./dropload/dropload');

export default new Api();

function Api() {
  this.cacheFlag = false;
  this.logFlag = false;
  _gs.init({
    dataType: 'JSONP',
    expire: 1, // 过期方式使用时间间隔
    isCleanDirtyStorage: true, // 开启脏数据清楚机制
    isCleanDataWhenFull: true, // 开启满数据清楚机制
    turnOnLogger: true, // 开启控制台输出
  });
}

/**
 * 与本地缓存模式结合的智能ajax
 * @param  {[obj]} data [在传统ajax参数的基础上增加localKey参数键（缓存在本地种的键值）]
 * @return promise对象
 */
Api.prototype.ajax = function (data) {
  var defer = $.Deferred();
  var localData = _gs.get({ keyName: data.localKey });

  var case1 = this.cacheFlag && localData && localData.result == 1,
    case2 =
      data.localItem && localData.data && localData.data.value[data.localItem];

  if (case1 && !data.localItem) {
    // case1:取出的本地缓存数据即为所求数据
    localData.data
      ? defer.resolve({
          isAjax: false,
          data: localData.data.value,
        })
      : defer.reject('本地尚未缓存数据！');
  } else if (case1 && case2) {
    // case2:取出的本地缓存数据中的某个item項为所求数据
    defer.resolve({
      isAjax: false,
      data: localData.data.value[data.localItem],
    });
  } else {
    // other:本地未缓存目标数据
    if (!data) data = {};
    data.success = function (res) {
      if (res.result == 1) {
        res.isAjax = true;
        defer.resolve(res);
      } else {
        defer.reject(res);
      }
    };
    data.error = defer.reject;

    $.ajax(data);
  }

  return defer.promise();
};

/**
 * 下拉加载数据
 * @param  {[type]} data [description]
 * @return Null
 */
/*Api.prototype.dropLoad = function(data){
    if(!data || !data.id) return;
    $(data.id).dropload({
        scrollArea:data.scrollArea || window,
        loadDownFn:function(me){
            data.action(me);
        },
        threshold : 10, // 提前加载距离
        distance:50 // 拉动距离
    });
}*/

/**
 * 对数据使用本地缓存模式
 * @param  {String} key       [一级key]
 * @param  {obj} data      [待缓存数据]
 * @param  {String} localItem [二级key]
 * @return {[type]}           [description]
 */
Api.prototype.cacheMode = function (key, data, localItem) {
  if (!this.cacheFlag) return;
  if (localItem) {
    var dataItem = {},
      local = _gs.get({ keyName: key }).data;
    local =
      local != null
        ? Object.prototype.toString.call(local.value).indexOf('Object') != -1
          ? local.value
          : {}
        : {};
    local[localItem] = data;
    data = local;
  }
  var item = {
    keyName: key,
    value: data,
    period: 60 * 1000, // 1 min 过期
  };

  _gs.save(item, function () {
    console.log('Update LocalStorage: ' + key);
  });
};

/**
 * 删除指定的缓存数据：支持删除指定的所有数据(key)和指定数据中的部分数据(item)
 * @param  {String} key  [本地缓存数据中的key值]
 * @param  {String} item [本地缓存数据中的部分数据]
 * @return Null
 */
Api.prototype.delCache = function (key, item) {
  if (!key) return;
  if (!item) {
    var res = _gs.del({ keyName: key });
    console.log('Del ' + key);
  } else {
    var res = _gs.get({ keyName: key });
    if (!res.result) return; // 查不到数据
    if (res.data.value instanceof Array) {
      // 数组
      res.data.value.splice(item, 1); // 删除下标为item的元素
    } else if (res.data.value instanceof Object) {
      // 对象
      delete res.data.value[item];
    }
    _gs.update(
      {
        // 更新数据
        keyName: key,
        value: res.data.value,
        period: 60 * 1000, // 1 min 过期
      },
      function () {
        console.log('Del ' + key + ' > ' + item);
      }
    );
  }
};

/**
 * 销毁本地缓存模式
 * @return {[type]} [description]
 */
Api.prototype.destoryCache = function () {
  _gs.flush(); // 清空全部数据
  this.cacheFlag = false;
  return new Api();
};

/**
 * 开启本地缓存模式
 * @return {[type]} [description]
 */
Api.prototype.activeCache = function () {
  this.cacheFlag = true;
  return new Api();
};

/**
 * 缓存的代理工厂
 * @param  {Function} fn [计算结果需要使用缓存的函数]
 * @return Null
 */
Api.prototype.proxyFactory = function (fn) {
  var cache = {};
  return function () {
    var args = Array.prototype.join.call(arguments, ',');
    if (args in cache) return cache[args];

    return (cache[args] = fn.apply(this, arguments));
  };
};

/**
 * 设置页面dom节点的高度
 * @param {object} opt{
 *        targetId: String [待设置高度的dom节点的选择器]
 *        containerId: String [基准容器节点的选择器]
 *        removeArr: Array [容器中需排除的dom节点列表]
 *        distance: Int [误差范围(负数表示减法)]
 * }
 */
Api.prototype.setMinHeight = function (opt) {
  if (!opt || !opt.targetId || !opt.removeArr) return;
  var removes = [];
  opt.removeArr instanceof Array
    ? (removes = opt.removeArr)
    : removes.push(opt.removeArr);
  var $ppr = 75;
  var container = opt.containerId ? $(opt.containerId) : $(window);
  var confH = container.height();
  for (var i = 0, l = removes.length; i < l; i++) {
    confH -= $(removes[i]).height();
  }
  if (opt.distance) confH += opt.distance;
  $(opt.targetId).css({ minHeight: confH });
};

/**
 * 验证规则策略库
 * @type {Object}
 */
var _strategies = {
  /**
   * 非空验证规则
   * @param  {String}  val    [用户的输入值]
   * @param  {String}  errMsg [验证失败的返回值]
   * @return {String/Undefined}        [验证成功返回undefined，验证失败返回errMsg]
   */
  isNonEmpty: function (val, errMsg) {
    if (val === '')
      return {
        node: this,
        msg: errMsg,
      };
  },
  /**
   * 最小长度验证规则
   * @param  {String}  val    [用户的输入值]
   * @param  {Int} len    [最小长度值]
   * @param  {String}  errMsg [验证失败的返回值]
   * @return {String/Undefined}        [验证成功返回undefined，验证失败返回errMsg]
   */
  minLength: function (val, len, errMsg) {
    if (val.length < len)
      return {
        node: this,
        msg: errMsg,
      };
  },
  isMobile: function (val, errMsg) {
    if (!/(^1[3|5|8][0-9]{9}$)/.test(val))
      return {
        node: this,
        msg: errMsg,
      };
  },
  isNumber: function (val, errMsg) {
    if (!/^\d+$/.test(val))
      return {
        node: this,
        msg: errMsg,
      };
  },
  isEmail: function (val, errMsg) {
    var reg =
      /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/;
    if (!reg.test(val)) {
      return {
        node: this,
        msg: errMsg,
      };
    }
  },
};

/**
 * 定义规则校验类
 * @return Null
 */
var _Validator = function () {
  this.cache = []; // 保存校验规则
  this.doms = []; // 保存注册过验证规则的dom
};

/**
 * 添加规则：同一规则在一个dom元素只允许被注册一次
 * @param {Node Object} dom   [待添加验证规则的dom元素]
 * @param {Array} rules [规则列表]
 */
_Validator.prototype.add = function (dom, rules) {
  var self = this;
  var id = dom.attr('id') || dom.attr('class');
  if (this.doms[id]) return; // 已经注册过校验规则
  this.doms[id] = 1; // 标记为已注册
  for (var i = 0, rule; (rule = rules[i++]); ) {
    (function (rule) {
      self.cache.push(function () {
        // 把校验的步骤用空函数包装起来，并且放入cache
        var strategyAry = rule.strategy.split(':'); // 把strategy 和参数分开
        var errMsg = rule.errMsg;
        var strategy = strategyAry.shift(); // 用户挑选的strategy
        strategyAry.unshift(dom.val()); // 把input 的value 添加进参数列表
        strategyAry.push(errMsg);
        return _strategies[strategy].apply(dom, strategyAry);
      });
    })(rule);
  }
};
/**
 * 执行验证规则列表
 * @return {String/Undefined}        [验证成功返回undefined，验证失败返回errMsg]
 */
_Validator.prototype.run = function () {
  for (var i = 0, validatorFunc; (validatorFunc = this.cache[i++]); ) {
    var errMsg = validatorFunc();
    if (errMsg) return errMsg;
  }
};

/**
 * 暴露表单验证功能接口
 * @return {Object} [验证类实例]
 */
Api.prototype.Validator = function () {
  return new _Validator();
};

/**
 * 表单验证功能
 * @param  {[Object]} data
 *                     {
 *                         node:[待验证的input节点],
 *                         verifications:[验证类列表，元素时一个对象]
 *                     }
 * @return {[Object]}
 *         {
 *             node:[验证未通过的dom节点],
 *             msg:[返回错误提示语]
 *         }
 */
var _verifyForm = function (data) {
  for (var i = 0, l = data.length; i < l; i++) {
    var verifications = [];
    data[i].verifications instanceof Array
      ? (verifications = data[i].verifications)
      : verifications.push(data[i].verifications);
    validator.add(data[i].node, verifications);
  }
  return validator.run();
};
/**
 * 表单验证代理函数
 * @param  {[Object]} data [同_verifyForm()]
 * @return {[Object]} [同_verifyForm()]
 */
Api.prototype.verifyForm = function (data) {
  var validator = this.Validator();
  for (var i = 0, l = data.length; i < l; i++) {
    var verifications = [];
    data[i].verifications instanceof Array
      ? (verifications = data[i].verifications)
      : verifications.push(data[i].verifications);
    validator.add(data[i].node, verifications);
  }
  return validator.run();
};

// 获取rem模式下的dpr
Api.prototype.getDpr = function () {
  var dpr = 1;
  if (window.navigator.appVersion.match(/iphone/gi)) {
    var devicePixelRatio = window.devicePixelRatio;
    // iOS下，对于2和3的屏，用2倍的方案，其余的用1倍方案
    if (devicePixelRatio >= 3) {
      dpr = 3;
    } else if (devicePixelRatio >= 2) {
      dpr = 2;
    } else {
      dpr = 1;
    }
  }
  return dpr;
};

Api.prototype.getMobileOS = function () {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone';
  }

  if (/android/i.test(userAgent)) {
    return 'Android';
  }

  // iOS detection from: //stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS';
  }

  return 'unknown';
};

/**
 * 打印日志
 * @param  txt [日志信息]
 * @return {[type]}     [description]
 */
Api.prototype.log = function (txt) {
  if (this.logFlag) {
    console.log(txt);
  }
};

Api.prototype.activeLog = function () {
  this.logFlag = true;
};
